import apontamentoColetasMatrizReport from "entity/Indicador/reports/ApontamentoColetasMatrizReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";

export default async function imvReport(indicador, visita) {
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const h = new TableReportHelper(apontamento);
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)

        const configIndicador = {
            showImplemento: false,
            showTrator: true,
            showFrente: true,
            showEquipamento: false,
            showMeta: true,
        }

        content.push([
            await apontamentoHeaderLocalizacaoReport(visita, indicador, apontamento, params, "Conformidade (%)", configIndicador, {
                label: "Operador",
                field: "operador.operador",
                width: "*"
            }),
            apontamentoColetasMatrizReport(
                visita,
                indicador,
                apontamento,
                ["Peso Total (kg)", "Peso Palha (kg)", "Peso Palha (%)", "Peso Palmito (kg)", "Peso Palmito (%)"],
                // prettier-ignore
                (h) => [
                    h.numberField("pesoTotal", { digits: 3, }),
                    h.numberField("pesoPalhaKg", { digits: 3 }),
                    h.numberField("pesoPalhaPc", { digits: 1 }),
                    h.numberField("pesoPalmitoKg", { digits: 3 }),
                    h.numberField("pesoPalmitoPc", { digits: 1 }),
                ],
                ['*', '*', '*', '*', '*']
            ),
            h.panel(
                [
                    // prettier-ignore
                    h.row(
                        h.title("Total de Impureza (kg)"),
                        h.title("Impureza Vegetal (%)"),
                    ),

                    // prettier-ignore
                    h.row(
                        h.numberField("totalImpureza", { digits: 3 }),
                        h.numberField("impurezaVegetal", { digits: 2 }),
                    ),
                ],
                { widths: ["*", "*"] }
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
